import Layout from "@/maintain/view/Layout";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "登录",
    component: () => import("@/maintain/view/Login"),
    hidden: true,
  },
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "首页",
        component: () => import("@/maintain/view/Home"),
      },
      {
        path: "/me",
        name: "我的",
        component: () => import("@/maintain/view/Me"),
      },
      {
        path: "/CellManagement",
        name: "小区管理",
        component: () =>
          import(
            "@/maintain/view/pages/PowerStationManage/CellManagement/CellManagement"
          ),
      },
      {
        path: "/DeviceManage",
        name: "设备管理",
        component: () =>
          import(
            "@/maintain/view/pages/PowerStationManage/MyPowerStation/MyPowerStation"
          ),
        meta: { title: "设备管理" },
      },
      {
        path: "/PowerStationDetail/:id",
        name: "设备详细",
        component: () =>
          import("@/maintain/view/pages/PowerStationManage/PowerStationDetail"),
        hidden: true,
        meta: { title: "设备详细" },
      },
      {
        path: "/DeviceExceptionInfo",
        name: "设备异常",
        component: () =>
          import("@/maintain/view/pages/PowerStationManage/DeviceExceptionInfo"),
        meta: {
          title: "设备异常",
        },
      },
      {
        path: "/OffLineLog",
        name: "离线统计",
        component: () =>
          import("@/maintain/view/pages/PowerStationManage/OffLineLog/OffLineLog"),
        meta: { title: "离线统计" },
      },
      {
        path: "/ElectricityCardManage",
        name: "全部电卡",
        component: () =>
          import("@/maintain/view/pages/ElectricityCardManage/ElectricityCardManage"),
        meta: { title: "全部电卡", icon: "icon-card" },
      },
      {
        path: "/ElectricityCardManage/:cardId",
        name: "电卡详细",
        component: () =>
          import(
            "@/maintain/view/pages/ElectricityCardManage/ElectricityCardDetail/ElectricityCardDetail"
          ),
        hidden: true,
        meta: { title: "电卡详细" },
      },
      {
        path: "/ElectricityCardTransferRecords",
        name: "转移记录",
        component: () =>
          import("@/maintain/view/pages/ElectricityCardManage/ElectricityCardManageThree"),
        meta: { title: "转移记录", icon: "icon-card" },
      },
      {
        path: "/GarageManage",
        name: "全部车库",
        component: () =>
          import("@/maintain/view/pages/GarageManage/GarageManage"),
      },
      {
        path: "/AccessControlDevice",
        name: "门禁管理",
        component: () => import("@/maintain/view/pages/GarageManage/AccessControlDevice"),
        meta: { title: "门禁管理" },
      },
      // {
      //     path: '/addDevice',
      //     name: '添加设备',
      //     component: () => import("@/maintain/view/addDevice"),
      // }, {
      //     path: '/chargeTemplate',
      //     name: '收费模板',
      //     component: () => import("@/maintain/view/chargeTemplate"),
      // }, {
      //     path: '/monthlyTemplate',
      //     name: '包月模板',
      //     component: () => import("@/maintain/view/monthly"),
      // }, {
      //     path: '/BaseInfo',
      //     name: '基础信息',
      //     component: () => import("@/maintain/view/BaseInfo"),
      // }, {
      //     path: '/deviceInfo',
      //     name: '设备详细',
      //     component: () => import("@/maintain/view/deviceInfo"),
      // }
    ],
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
  base: "/maintain.html/",
});

export default router;
